<script setup>
import TvTable from '~/components/tv/TvTable.vue';
import TvTeamName from '~/components/tv/TvTeamName.vue';
import {tvPages, tvRowsPerPage} from '~/utils/tvDisplay';

// A league division's table (current cycle; approved results only)
const props = defineProps({
  panel: {type: Object, required: true},
  page: {type: Number, default: 0},
});
// wide, column or portrait (set by the panel's frame)
const mode = inject('tvMode', ref('wide'));

const division = computed(() => props.panel.standings ?? {rows: []});
const rows = computed(() => tvPages(division.value.rows, tvRowsPerPage(props.panel, 'table', mode.value))[props.page] ?? []);
const hasBonus = computed(() => division.value.rows.some(r => r.bonusPoints));

// Portrait screens are narrower: short headings and tighter number columns
const columns = computed(() => {
  const narrow = mode.value !== 'wide';
  return [
    {key: 'position', label: '', width: narrow ? '84px' : '110px'},
    {key: 'teamName', label: division.value.playersPerTeam === 1 ? 'Player' : 'Team'},
    {key: 'played', label: narrow ? 'P' : 'Played', num: true, width: narrow ? '96px' : '170px'},
    ...(hasBonus.value ? [{key: 'bonusPoints', label: narrow ? 'B' : 'Bonus', num: true, width: narrow ? '96px' : '170px'}] : []),
    {key: 'totalPoints', label: narrow ? 'Pts' : 'Points', num: true, strong: true, width: narrow ? '120px' : '190px'},
  ];
});
</script>

<template>
  <tv-table :columns="columns" :rows="rows" :row-key="r => r.position + r.teamName" :lead="page === 0 && division.rows.some(r => r.played > 0) ? 1 : 0">
    <template #teamName="{row}"><tv-team-name :name="row.teamName"/></template>
  </tv-table>
</template>
